"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var RootState = (_class = /*#__PURE__*/function () {
  function RootState() {
    _classCallCheck(this, RootState);
  }
  return _createClass(RootState, [{
    key: "set",
    value: function set(field, value) {
      this[field] = value;
    }
  }, {
    key: "toggle",
    value: function toggle(field) {
      this[field] = !this[field];
    }
  }, {
    key: "incrementId",
    value: function incrementId(ary, field) {
      this[field] = StateHelper.incrementId(ary, this[field]);
    }
  }, {
    key: "decrementId",
    value: function decrementId(ary, field) {
      this[field] = StateHelper.decrementId(ary, this[field]);
    }
  }, {
    key: "cloneEventParams",
    value: function cloneEventParams(params) {
      return params ? JSON.parse(JSON.stringify(params)) : {};
    }
  }, {
    key: "onCreateEventBlocked",
    value: function onCreateEventBlocked() {}
  }, {
    key: "onCreateEventStart",
    value: function onCreateEventStart() {}
  }, {
    key: "nativeCreateEventArgs",
    value: function nativeCreateEventArgs() {
      return {};
    }
  }, {
    key: "createEventOnServer",
    value: function createEventOnServer(eventType, params) {
      if (this.eventStore) {
        this.eventStore.create({
          data: {
            eventType: eventType,
            params: params
          }
        }, _lodash.noop);
      }
    }
  }, {
    key: "dispatchFrontendEvent",
    value: function dispatchFrontendEvent(_ref) {
      var eventType = _ref.eventType,
        _ref$params = _ref.params,
        params = _ref$params === void 0 ? {} : _ref$params,
        _ref$layoutIsNative = _ref.layoutIsNative,
        layoutIsNative = _ref$layoutIsNative === void 0 ? false : _ref$layoutIsNative,
        nativeCreateEventHandler = _ref.nativeCreateEventHandler,
        _ref$nativeCreateEven = _ref.nativeCreateEventArgs,
        nativeCreateEventArgs = _ref$nativeCreateEven === void 0 ? {} : _ref$nativeCreateEven,
        _ref$webPosthogTracki = _ref.webPosthogTrackingAllowed,
        webPosthogTrackingAllowed = _ref$webPosthogTracki === void 0 ? false : _ref$webPosthogTracki,
        buildPosthogParams = _ref.buildPosthogParams,
        sendToServer = _ref.sendToServer,
        _ref$frontendOnlyEven = _ref.frontendOnlyEvent,
        frontendOnlyEvent = _ref$frontendOnlyEven === void 0 ? (0, _utils.isFrontendOnlyEvent)(eventType) : _ref$frontendOnlyEven;
      if (this.user && this.user.blockUserTracking) {
        return {
          status: 'blocked',
          frontendOnlyEvent: frontendOnlyEvent
        };
      }
      if (layoutIsNative && (0, _lodash.isFunction)(nativeCreateEventHandler)) {
        nativeCreateEventHandler(_objectSpread({
          eventType: eventType,
          params: params,
          frontendOnly: frontendOnlyEvent,
          sendToServer: sendToServer
        }, nativeCreateEventArgs));
        return {
          status: 'native',
          frontendOnlyEvent: frontendOnlyEvent
        };
      }
      if (!layoutIsNative && webPosthogTrackingAllowed && (0, _lodash.isFunction)(buildPosthogParams)) {
        var tracked = (0, _utils.capturePosthogEvent)(eventType, buildPosthogParams(params));
        if (tracked || frontendOnlyEvent) {
          return {
            status: tracked ? 'web' : 'frontend_only',
            frontendOnlyEvent: frontendOnlyEvent
          };
        }
      }
      if (frontendOnlyEvent) {
        return {
          status: 'frontend_only',
          frontendOnlyEvent: frontendOnlyEvent
        };
      }
      if ((0, _lodash.isFunction)(sendToServer)) {
        sendToServer();
        return {
          status: 'server',
          frontendOnlyEvent: frontendOnlyEvent
        };
      }
      return {
        status: 'skipped',
        frontendOnlyEvent: frontendOnlyEvent
      };
    }
  }, {
    key: "createEvent",
    value: function createEvent(eventType, params) {
      var _this = this;
      if (this.user && this.user.blockUserTracking) {
        this.onCreateEventBlocked(eventType);
        return;
      }
      var safeParams = this.cloneEventParams(params);
      this.onCreateEventStart(eventType, safeParams);
      this.dispatchFrontendEvent({
        eventType: eventType,
        params: safeParams,
        layoutIsNative: Boolean(this.layout && this.layout.isNative),
        nativeCreateEventHandler: this.nativeCreateEventHandler,
        nativeCreateEventArgs: this.nativeCreateEventArgs(eventType, safeParams),
        webPosthogTrackingAllowed: (0, _lodash.isFunction)(this.webPosthogTrackingAllowed) && this.webPosthogTrackingAllowed(),
        buildPosthogParams: (0, _lodash.isFunction)(this.posthogEventParams) ? function (eventParams) {
          return _this.posthogEventParams(eventType, eventParams);
        } : undefined,
        sendToServer: function sendToServer() {
          return _this.createEventOnServer(eventType, safeParams);
        }
      });
    }
  }]);
}(), _applyDecoratedDescriptor(_class.prototype, "set", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggle", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incrementId", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "decrementId", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "decrementId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createEvent", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createEvent"), _class.prototype), _class);
var _default = exports["default"] = RootState;